// import './App.css';
// import Home from './Pages/home';
// import React from 'react';
// import { useState} from 'react';
// import { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import Header from './Components/Header';
// import Footer from './Components/Footer';
// import 'aos/dist/aos.css'; // Import AOS styles
// import AOS from 'aos';
// import PageNotFound from './Pages/404';

// import Contact from './Pages/contactus';
// import Products from './Pages/products/products'
// import LoginModal from './Pages/Login/Login'
// import Register from './Pages/Register/Register';
// import LeftSideNavaBarAdmin from './Components/AdminDashBoard/LeftSideNavaBarAdmin';
// import AdminDashBoard from './Components/AdminDashBoard/AdminDashBoard';
// import ProductMangement from './Components/AdminDashBoard/ProductMangement';
// import OrderManagement from './Components/AdminDashBoard/OrderManagement';
// import StockMangement from './Components/AdminDashBoard/StockMangement';
// import ReportAnalytics from './Components/AdminDashBoard/ReportAnalytics';
// import InventoryMangement from './Components/AdminDashBoard/InventoryMangement';
// import DeliveryMangement from './Components/AdminDashBoard/DeliveryMangement';
// import Accounting from './Components/AdminDashBoard/Accounting';
// import Category from './Components/AdminDashBoard/Category';
// import Subcategory from './Components/AdminDashBoard/Subcategory';
// import Product from './Components/AdminDashBoard/AddProduct';
// const App = () => {
//   const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Open modal when the path is /login
//     if (location.pathname === '/login') {
//       setIsLoginModalOpen(true);
//     }
//   }, [location.pathname]);

//   const handleCloseLoginModal = () => {
//     setIsLoginModalOpen(false);
//     // Only update URL if we're on the login page
//     if (location.pathname === '/login') {
//       navigate('/', { replace: true });
//     }
//   };

//   const handleLoginClick = (e) => {
//     if (location.pathname === '/login') {
//       e.preventDefault();
//       setIsLoginModalOpen(true);
//     }
//   };
//   useEffect(() => {
//     AOS.init();
//   }, []);
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Header onLoginClick={handleLoginClick}/>

//         <Routes>
//           <Route path='/' element={<Home />} />
//           <Route path="*" element={<PageNotFound />} />
//           <Route path = "/contactus" element={<Contact/>}/>
//           <Route path="/products" element={<Products/>}/>
//           {/* <Route path="/login" element={<Login/>}/> */}
//           <Route path="/register" element={<Register/>}/>
//           <Route path="/AdminDashBoard" element={<AdminDashBoard/>}/>
//           <Route path="/LeftSideNavaBarAdmin" element={<LeftSideNavaBarAdmin/>}/>
//           <Route path="/productmanagement" element={<ProductMangement/>}/>
//           <Route path="/ordermanagement" element={<OrderManagement/>}/>
//           <Route path="/stockmanagement" element={<StockMangement/>}/>
//           <Route path="/reportanalystics" element={<ReportAnalytics/>}/>
//           <Route path="/inventorymanagement" element={<InventoryMangement/>}/>
//           <Route path="/deliverymanagement" element={<DeliveryMangement/>}/>
//           <Route path="/accounting" element={<Accounting/>}/>
//           <Route path="/Category" element={<Category/>}/>
//           <Route path="/Subcategory" element={<Subcategory/>}/>
//           <Route path="/Product" element={<Product/>}/>
//           <LoginModal
//         isOpen={isLoginModalOpen}
//         onClose={handleCloseLoginModal}
//       />
//         </Routes>
//         <Footer/>
//       </BrowserRouter>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import Home from "./Pages/home";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import "aos/dist/aos.css";
import AOS from "aos";
import Privacy_policy from "./Pages/Policy/Privacy_policy/Privacy_policy";
import FAQ from "./Pages/Policy/FAQ/faq";
import Terms_and_Conditions from "./Pages/Policy/Terms_and_Conditions/TermsandConditions";
import Shipping_policy from "./Pages/Policy/Shipping_policy/Shipping_policy";
import CancellationandRefundPolicy from "./Pages/Policy/Cancellation_and_Refund_Policy/CancellationandRefundPolicy";
import Exchange_and_Return_Policy from "./Pages/Policy/ExchangeandReturnPolicy/ExchangeandReturnPolicy";
import PageNotFound from "./Pages/404";
import Contact from "./Pages/contactus";
import Products from "./Pages/products/products";
import Register from "./Pages/Register/Register";
import ChatBot from "./Components/CHATBOT/ChatBot";
import LeftSideNavaBarAdmin from "./Components/AdminDashBoard/LeftSideNavaBarAdmin";
import AdminDashBoard from "./Components/AdminDashBoard/AdminDashBoard";
import ProductMangement from "./Components/AdminDashBoard/ProductMangement";
import OrderManagement from "./Components/AdminDashBoard/OrderManagement";
import StockMangement from "./Components/AdminDashBoard/StockMangement";
import ReportAnalytics from "./Components/AdminDashBoard/ReportAnalytics";
import InventoryMangement from "./Components/AdminDashBoard/InventoryMangement";
import DeliveryMangement from "./Components/AdminDashBoard/DeliveryMangement";
import Accounting from "./Components/AdminDashBoard/Accounting";
import Category from "./Components/AdminDashBoard/Category";
import Subcategory from "./Components/AdminDashBoard/Subcategory";
import Product from "./Components/AdminDashBoard/AddProduct";
import LoginModal from "./Pages/Login/Login";
import Preview from "./Pages/preview/preview";
import ProductName from "./Components/AdminDashBoard/ProductName";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import { CartProvider } from "./Pages/CartContext/CartContext";
import CartPage from "./Pages/Cart/Cart";
import Checkout from "./Pages/Checkout/Checkout";
import OrderConfirmation from "./Pages/UserOrder/Order";
import AdminOrders from "./Components/AdminDashBoard/Adminorder";
import UserHome from "./Pages/userdash/userhome/userhome";
import UserOrder from "./Pages/userdash/userorder/userorder";
import Address from "./Pages/userdash/useraddress/useraddress";
import Categoryedit from "./Components/AdminDashBoard/Categoryedit";
import ScrollToTop from "./Components/scrollup";
import Userorderdetails from "./Pages/userdash/userorderdetails/userorderdetails";
import HomeKarthik from "./Pages/home2";
import Aboutus from "./Pages/aboutus/Aboutus";
import AboutUsTerra from './Pages/AboutUsTerra/AboutUsTerra/AboutUsTerra'
import WhatsAppPopup from "./Components/WhatsAppButton/WhatsAppButton";

// import Address from './Pages/userdash/Address';
// AppContent component - contains all routes and components that need router context
const AppContent = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Effect to handle login modal on route change
  useEffect(() => {
    if (location.pathname === "/login") {
      setIsLoginModalOpen(true);
    }
  }, [location.pathname]);

  // Initialize AOS (Animate On Scroll)
  useEffect(() => {
    AOS.init();
  }, []);

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
    if (location.pathname === "/login") {
      navigate("/", { replace: true });
    }
  };

  const handleLoginClick = (e) => {
    if (location.pathname === "/login") {
      e.preventDefault();
      setIsLoginModalOpen(true);
    }
  };

  return (
    <div className="App">
      <Header onLoginClick={handleLoginClick} />
      {/* <Address/> */}
      {/* <TranslateWidget/> */}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomeKarthik />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/products" element={<Products />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<HomeKarthik />} />
        <Route path="/aboutus" element={<AboutUsTerra />} />
        <Route path="/Userorderdetails" element={<Userorderdetails />} />
        <Route path="/userprofile" element={<UserHome />} />
        <Route path="/userorder" element={<UserOrder />} />
        <Route path="/Address" element={<Address />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/Checkout" element={<Checkout />} />
        <Route path="/OrderConfirmation" element={<OrderConfirmation />} />
        <Route path="/Privacy-policy" element={<Privacy_policy />} />
        <Route path="/Shipping-policy" element={<Shipping_policy />} />
        <Route
          path="/Cancellation-and-Refund-policy"
          element={<CancellationandRefundPolicy />}
        />
        <Route
          path="/Exchange-and-Return-policy"
          element={<Exchange_and_Return_Policy />}
        />
        <Route
          path="/Terms-and-Conditions-policy"
          element={<Terms_and_Conditions />}
        />
        <Route path="/FAQs" element={<FAQ />} />
        <Route
          path="/AdminDashBoard"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminDashBoard />
            </PrivateRoute>
          }
        />
        <Route
          path="/LeftSideNavaBarAdmin"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <LeftSideNavaBarAdmin />
            </PrivateRoute>
          }
        />
        <Route
          path="/productmanagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <ProductMangement />
            </PrivateRoute>
          }
        />
        <Route
          path="/AdminOrders"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminOrders />
            </PrivateRoute>
          }
        />
        <Route
          path="/EditCategory"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Categoryedit />
            </PrivateRoute>
          }
        />
        <Route
          path="/ordermanagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <OrderManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/stockmanagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <StockMangement />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportanalystics"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <ReportAnalytics />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventorymanagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <InventoryMangement />
            </PrivateRoute>
          }
        />
        <Route
          path="/deliverymanagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <DeliveryMangement />
            </PrivateRoute>
          }
        />
        <Route
          path="/accounting"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Accounting />
            </PrivateRoute>
          }
        />
        <Route
          path="/Category"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Category />
            </PrivateRoute>
          }
        />
        <Route
          path="/Subcategory"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Subcategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/Product"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Product />
            </PrivateRoute>
          }
        />
        <Route
          path="/ProductName"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <ProductName />
            </PrivateRoute>
          }
        />

        {/* 404 Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      <LoginModal isOpen={isLoginModalOpen} onClose={handleCloseLoginModal} />
      
      <WhatsAppPopup />
      <ChatBot />
      <Footer />
    </div>
  );
};

// Main App component
const App = () => {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppContent />
      </BrowserRouter>
    </CartProvider>
  );
};

export default App;
